<template>
  <!-- Content area -->
  <div class="card">
    <div class="card-header border-bottom">
      <h5 class="card-title">
        <i class="fas fa-analytics mr-2" />{{ $t("Reports") }}
      </h5>
      <div>
        {{
          $t(
            "Center for statistics on selling products giving you an overview of the store And use the information to manage your store to sell better."
          )
        }}
      </div>
    </div>
    <div class="card-body py-3">
      <div class="row mb-3">
        <!-- Orders -->
        <div class="col-md-12">
          <div class="card border-0">
            <div class="card-header border bg-light p-2 px-3">
              <h5 class="mb-0">
                <i class="far fa-shopping-cart mr-2" />{{ $t("Orders") }}
              </h5>
            </div>
            <div class="card-body m-0 pt-0 px-2">
              <div class="row">
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-left border-bottom border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.orders.totalSales' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Total Sales Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li
                      v-if="$store.state.user.feature.includes('report-sales-by-province')"
                    >
                      <router-link
                        :to="{ name: 'admin.reports.orders.salesReportByProvince' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Sales Report By Province") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.orders.groupSalesOrderPayment' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Bank Account Payment Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li
                      v-if="this.$store.state.user.feature.includes('feature-salepage')"
                    >
                      <router-link
                        :to="{ name: 'admin.reports.orders.salepage' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Sales Report by Sale Page") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.orders.reportByChannel' }"
                        class="
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("_ReportChannel.Sales Order Report by Channel") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.orders.totalPayments' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Payment Report by Payment Channel") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name:'admin.reports.orders.salesReportByDaily' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Sales Report by Daily and Period") }}<i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li
                      v-if="$store.state.user.feature.includes('report-upsell')"
                    >
                      <router-link
                        :to="{ name: 'admin.reports.orders.upsell' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Sales Order By Order Upsell") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipments -->
        <div class="col-md-12">
          <div class="card border-0">
            <div class="card-header border bg-light p-2 px-3">
              <h5 class="mb-0">
                <i class="fa-solid fa-truck mr-2" />{{ $t("Shipments") }}
              </h5>
            </div>
            <div class="card-body m-0 pt-0 px-2">
              <div class="row">
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-left border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.payments.cashOnDelivery' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Cash on Delivery Payment Report (COD)") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.payments.shippingExpensesReport' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Shipping Charge Billing Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Product -->
        <div class="col-md-12">
          <div class="card border-0">
            <div class="card-header border bg-light p-2 px-3">
              <h5 class="mb-0">
                <i class="fa-solid fa-boxes-stacked mr-2" />{{ $t("Product") }}
              </h5>
            </div>
            <div class="card-body m-0 pt-0 px-2">
              <div class="row">
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-left border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.products.bestSeller' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Best Seller Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.products.sales' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Product Sales Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                    <li v-if="this.$store.state.user.feature.includes('feature-product-category')">
                      <router-link
                        :to="{ name: 'admin.reports.products.category' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Product Sales Report By Category") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.products.return' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Parcel Return Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Inventory -->
        <div class="col-md-12" v-if="wmsService == 2">
          <div class="card border-0">
            <div class="card-header border bg-light p-2 px-3">
              <h5 class="mb-0">
                <i class="fa-solid fa-truck mr-2" />{{ $t("Inventory") }}
              </h5>
            </div>
            <div class="card-body m-0 pt-0 px-2">
              <div class="row">
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-left border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.Inventory.ReportInventory' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Inventory Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>

                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-left border-right media-list">
                    <li>
                      <router-link
                        :to="{ name: 'admin.reports.Inventory.StockAgingReport' }"
                        class="
                          border-bottom
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Stock Aging Report") }}
                        <i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- VoIP -->
        <div
          class="col-md-12"
          v-if="this.$store.state.user.feature.includes('report-call-history') || this.$store.state.user.planLastPurchase.find(plan => plan.series === 'advance' || plan.series === 'vip')"
        >
          <div class="card border-0">
            <div class="card-header border bg-light p-2 px-3">
              <h5 class="mb-0">
                <i class="fa-solid fa-phone-volume rotate-45-inverse mr-2" />{{ $t("Voice over Internet Protocol (VoIP)") }}
              </h5>
            </div>
            <div class="card-body m-0 pt-0 px-2">
              <div class="row">
                <div class="col-sm-12 col-md-6 p-0 m-0">
                  <ul class="border-left border-bottom border-right media-list">
                    <li>
                      <router-link
                        :to="{ name:'admin.reports.orders.voiceCall' }"
                        class="
                          justify-content-between
                          list-group-item list-group-item-action
                          text-body text-capitalize
                        "
                        target="_blank"
                      >
                        {{ $t("Call History Report") }}<i class="icon-arrow-right32 ml-3" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import Cookies from 'js-cookie';
export default {
  name: "MainReports",
  components: {},
  data() {
    return {
      wmsService: Cookies.get('WmsSevice'),
    };
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/Index.vue